import { Link } from "react-router-dom";
import { useSite } from "@/context/SiteContext";

export const DEFAULT_NAME = "KPR AC News";
export const DEFAULT_TAGLINE = "Kilpennathur Assembly Constituency News";
export const DEFAULT_TAGLINE_TA = "கீழ்பென்னாத்தூர் சட்டமன்றத் தொகுதி செய்திகள்";
// Category/trend navigation is hidden until there is enough content.
export const SHOW_SECTIONS = false;

export const useBrand = () => {
  const { settings, lang } = useSite();
  const tagline = lang === "ta"
    ? settings.tagline_ta || DEFAULT_TAGLINE_TA
    : settings.tagline || DEFAULT_TAGLINE;
  return { name: settings.site_name || DEFAULT_NAME, tagline, lang };
};

const SIZES = {
  header: { name: "text-2xl sm:text-3xl", tag: "text-[11px] sm:text-xs mt-1", wrap: "flex flex-col items-start" },
  footer: { name: "text-3xl text-white", tag: "text-sm text-blue-200 mt-2", wrap: "flex flex-col" },
  compact: { name: "text-xl", tag: "text-[11px] mt-0.5", wrap: "flex flex-col" },
  auth: { name: "text-2xl", tag: "text-xs mt-1", wrap: "flex flex-col items-start" },
};

export const Brand = ({ variant = "header", testId = "site-logo" }) => {
  const { name, tagline, lang } = useBrand();
  const s = SIZES[variant];
  const ta = lang === "ta";
  return (
    <Link to="/" data-testid={testId} className={`${s.wrap} min-w-0 group`}>
      <span className={`font-serif-head font-black tracking-tight leading-tight ${variant === "footer" ? "" : "text-[#0B2A5B]"} ${s.name}`}>{name}</span>
      <span data-testid={`${testId}-tagline`} className={`font-semibold ${ta ? "lang-ta tracking-normal" : "uppercase tracking-[0.12em]"} ${variant === "footer" ? "" : "text-[#1D4ED8]"} ${s.tag}`}>
        {tagline}
      </span>
    </Link>
  );
};
